<template>
  <el-drawer
    v-model="visible"
    :close-on-click-modal="closeDrawerOnOutsideClick"
    :modal="false"
    :append-to-body="false"
    :fullscreen="false"
    :size="drawerWidthPct"
    destroy-on-close
    class="link-conversations-drawer"
    modal-class="link-conversations-drawer"
    @opened="onOpened"
    @closed="onClosed"
  >
    <template #header>
      <div v-if="drawerOpened" class="link-conversations-drawer__header">
        <h1>Link Conversation</h1>
        <h2>
          <i class="ddi ddi-task" />
          #{{originatingTask.refNumber}} {{originatingTask.title}}
        </h2>
      </div>
    </template>
    <template v-if="drawerOpened">
      <!-- LINK EXISTING CONVERSATIONS -->
      <link-existing-conversations-panel
        :currently-linked-conversations="currentlyLinkedConversations"
        @canceled="handleCancel()"
        @selected-existing-conversation-id="(id) => $emit('selected-existing-conversation-id', id)"
      />
    </template>
  </el-drawer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import {
  IItemReference,
  ILinkedItemForListing,
} from '@/api/types/response.types'

export default defineComponent({
  name: 'LinkConversationsDrawer',

  props: {
    showDrawer: {
      type: Boolean,
      default: false,
    },
    currentlyLinkedConversations: {
      type: Array as () => ILinkedItemForListing[],
      required: true,
    },
    originatingTask: {
      type: Object as () => IItemReference,
      default: null,
    },
  },

  emits: ['selected-existing-conversation-id', 'update:showDrawer'],

  data() {
    return {
      isLoading: false,
      closeDrawerOnOutsideClick: true,
      drawerOpened: false,
    }
  },

  computed: {
    visible: {
      get(): boolean {
        return this.showDrawer
      },
      set(newValue: boolean) {
        this.$emit('update:showDrawer', newValue)
      },
    },
    drawerWidthPct(): string {
      if (this.$screen.isMobile(this.$mq)) {
        return '100%'
      }
      return '524px'
    },
  },

  methods: {
    onOpened() {
      this.drawerOpened = true
    },

    onClosed() {
      this.drawerOpened = false
    },

    handleCancel() {
      this.$emit('update:showDrawer', false)
    },
  },
})
</script>

<style lang="scss">
.link-conversations-drawer {
  /* Default drawer overrides */
  .el-drawer__header {
    padding-bottom: 0;
  }
  .el-drawer__body {
    background-color: var(--color-background-secondary);
  }

  &__header {
    display: flex;
    padding: 20px 0 0 20px;
    flex-direction: column;
    align-items: flex-start;

    > h1 {
      font-size: 22px !important;
      font-weight: 500 !important;
      margin-bottom: 4px !important;
    }

    > h2 {
      @include lettering--p-sm;
      color: var(--color-text-third);
      @include single-line-ellipsis;
      max-width: 420px;

      @include media-breakpoint-down(sm) {
        max-width: 360px;
      }
    }
  }
}
</style>
